import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';

function Click({ DropElement, children, onClose, render, ...props }) {
    const [show, setShow] = useState(false);

    const closeHandler = useCallback(
        () => {
            setShow(false);
            onClose();
        },
        [onClose]
    );

    const clickHandler = useCallback(
        (e) => {
            children.props && children.props.onClick && children.props.onClick(e);
            setShow(!show);
            if (show) {
                onClose();
            }
        },
        [show, onClose, children.props]
    );

    const renderFunc = useCallback(() => render(closeHandler), [render, closeHandler]);

    return (
        <DropElement {...props} show={show} onClose={closeHandler} render={renderFunc}>
            {React.cloneElement(children, { onClick: clickHandler })}
        </DropElement>
    );
}

export default Click;

Click.propTypes = {
    /** Колбек, вызывающийся, когда дроповер закрылся */
    onClose: PropTypes.func,
    /** Элемент инициатор, относительно которого показывать DropOver */
    children: PropTypes.node,
    /** Метод-рендер контента дропдауна */
    render: PropTypes.func.isRequired,
    /** Любой компонент Drop */
    DropElement: PropTypes.func,
};

Click.defaultProps = {
    onClose: () => {},
};
